import { useState } from 'react'
import { Tab } from 'react-bootstrap';
import EmailUser from "./EmailUser";
// import MobileUser from './MobileUser'
import loginlogo from '../styles/webroot/images/login_logo.png'
import ReactSlider from '@src/common/ReactSlider';


const loginLeft = {
    backgroundImage: `url("/images/Group_1000005712.png")`,
    backgroundColor: "#0B1E51",
    backgroundRepeat: "repeat-y",
    backgroundPosition: "center",
    borderRadius: "25px"
}


function Register() {
    
    // eslint-disable-next-line
    const [showMobileLinks, setShowMobileLinks] = useState(true);
    // eslint-disable-next-line
    const [showEmailLinks, setShowEmailLinks] = useState(true);
    const [isOtpVerifyScreen, setIsOtpVerifyScreen] = useState(false);

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="login-outer register-outer">
                    <div className="login-left-panel slider-left-pannel-web" style={loginLeft}>
                        <ReactSlider screenType="Register"></ReactSlider>
                    </div>
                    <div className="login-right-panel t-center">
                        <div className="logo-img">
                            <img src={loginlogo} className="" alt='logo' />
                        </div>
                        <div className="login-heading m-md-t">
                            <h2>
                                {
                                 isOtpVerifyScreen ? 
                                 "Verify OTP" :
                                 "Register With Us"
                                }
                            </h2>
                        </div>
                        <div className="p-lg-t t-center">
                            <label>
                                {
                                 isOtpVerifyScreen ? 
                                 "Enter the OTP sent on register email id" :
                                 "Enter your details to create your account"
                                }
                            </label>
                        </div>
                        <Tab.Container id="" defaultActiveKey="first">
                            <div className="login-tab">

                                {/* <Nav variant="pills" className="flex-column" onSelect={() => activeTabHandler()}>
                                    {(showEmailLinks && showMobileLinks) &&

                                        <Nav.Item>
                                            <Nav.Link eventKey="first">By Email</Nav.Link>
                                        </Nav.Item>
                                    }
                                    {(showEmailLinks && showMobileLinks) &&
                                        <Nav.Item>
                                            <Nav.Link eventKey="second">By Mobile</Nav.Link>
                                        </Nav.Item>
                                    }
                                </Nav> */}


                                <Tab.Content>
                                    <Tab.Pane eventKey="first">
                                        <EmailUser setShowEmailLinks = {setShowEmailLinks} setShowMobileLinks = {setShowMobileLinks} setIsOtpVerifyScreen={setIsOtpVerifyScreen} isRegister={true} />

                                    </Tab.Pane>
                                    {/* <Tab.Pane eventKey="second">
                                        <MobileUser setShowEmailLinks = {setShowEmailLinks} setShowMobileLinks = {setShowMobileLinks}  showCaptcha={showCaptcha} />
                                    </Tab.Pane> */}
                                </Tab.Content>
                            </div>
                        </Tab.Container>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Register